import { Link } from 'react-router-dom'

import style from './seeAll.module.css'

/**
 * "See all on Chimp" — the footer link every content panel carries.
 *
 * Points at the feed pre-filtered to this company via ?q=, which DiscoverView
 * now seeds its search from. The panels only ever hold a sample (20 rows), so
 * without this the reader has no way to reach the rest, and "scroll to see more"
 * was promising something the panel could not deliver.
 */
const SeeAllOnChimp = ({ companyName, label = 'See all on Chimp' }) => {
  if (!companyName) return null

  return (
    <Link
      className={style.seeAll}
      to={`/dashboard/home?q=${encodeURIComponent(companyName)}`}
      data-log-action="spotlight_see_all_on_chimp"
    >
      {label}
      <span aria-hidden="true">→</span>
    </Link>
  )
}

export default SeeAllOnChimp
